// import { MapsAPILoader } from '@agm/core';
import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Loader } from '@googlemaps/js-api-loader';
import { MapApiKey } from 'src/app/utils/systemEnums';

@Component({
  selector: 'app-search-city-google-map-dialog',
  templateUrl: './search-city-google-map-dialog.component.html',
  styleUrls: ['./search-city-google-map-dialog.component.scss'],
})
export class SearchCityGoogleMapDialogComponent implements OnInit {
  form!: FormGroup;
  latitude!: any;
  longitude!: any;
  zoom: number;
  selectedCountryCode: string;
  address!: string;
  mapLoadingTimes = 0;
  private geoCoder;
  selectedCountry;
  @ViewChild('search', { static: true })
  public searchElementRef!: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<SearchCityGoogleMapDialogComponent>,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private _fb: FormBuilder
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.loadPlaceAutoComplete();
  }

  noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  }

  createForm() {
    this.form = this._fb.group({
      pickupAddress: ['', [Validators.required, this.noWhitespaceValidator]],
    });
  }

  loadPlaceAutoComplete() {
    // Check if Google Maps is already loaded
    if (typeof google !== 'undefined' && google.maps) {
      this.initializeGoogleMaps();
      return;
    }

    // Only load if not already present
    const loader = new Loader({
      apiKey: MapApiKey,
      libraries: ['places'],
    });

    loader.load().then(() => {
      this.initializeGoogleMaps();
    }).catch((error) => {
      console.error('Failed to load Google Maps:', error);
    });
  }

  private initializeGoogleMaps() {

    console.log('initializeGoogleMaps called', this._data.countryCode ? this._data.countryCode == '+233' ? "GH" : 'NG' : localStorage.getItem('country') === 'Ghana' ? 'GH' : 'NG');
    this.geoCoder = new google.maps.Geocoder();

    const autocomplete = new google.maps.places.Autocomplete(
      this.searchElementRef?.nativeElement,
      {
        componentRestrictions: {
          country: this._data.countryCode ? this._data.countryCode == '+233' ? "GH" : 'NG' : localStorage.getItem('country') === 'Ghana' ? 'GH' : 'NG',
        },
      }
    );

    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
          // User entered the name of a Place that was not suggested and pressed the Enter key,
          // or the Place Details request failed.
          window.alert(
            "No details available for input: '" + place.name + "'"
          );
          return;
        }

        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;

        console.log('place', place);
        // Set the form control value directly with the formatted address from the selected place
        if (place.formatted_address) {
          this.form.get('pickupAddress')?.setValue(place.formatted_address);
          this.address = place.formatted_address; // Also update component property for consistency
        } else {
          // Fallback to getAddress if for some reason formatted_address is not directly available
          this.getAddress(this.latitude, this.longitude);
        }
      });
    });
  }

  getAddress(latitude, longitude) {
    if (this.geoCoder)
      this.geoCoder?.geocode(
        { location: { lat: latitude, lng: longitude } },
        (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              if (!this.zoom) this.zoom = 12;
              this.address = results[0].formatted_address;
              console.log('address', this.address);
              // Update the form control here with the full formatted address obtained from geocoding
              this.form.get('pickupAddress')?.setValue(this.address);
              this.handleAddressChange(results[0]);
              this.mapLoadingTimes++;
            } else {
              window.alert('No results found');
            }
          } else {
            window.alert('Geocoder failed due to: ' + status);
          }
        }
      );
  }

  public handleAddressChange(address) {
    const addCompLength = address.address_components.length;

    const addressParts = {
      city: address.address_components.filter((item) => {
        // console.log("address item", item);
        if (
          item.types[0] == 'administrative_area_level_3' ||
          item.types[0] == 'political'
        )
          return item.long_name;
      })[0],

      landMark: address.address_components.filter((item) => {
        if (item.types[2] == 'sublocality_level_1') return item.long_name;
      })[0],

      state: address.address_components.filter((item) => {
        if (item.types[0] == 'administrative_area_level_1')
          return item.long_name;
      })[0],

      country: address.address_components.filter((item) => {
        if (item.types[0] == 'country') return item.long_name;
      })[0],

      zipcode: address.address_components.filter((item) => {
        if (item.types[0] == 'postal_code') return item.long_name;
      })[0],
    };

    // console.log("addressParts", addressParts);

    // this.form.get('pickupAddress').setValue(addressParts.city.long_name);
  }
}
